export default __webpack_public_path__ + "4cee3bff53ceab57cc686b67639a27de.wav";